module.exports = __webpack_public_path__ + "static/img/11.a6d49a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/11.png
// module id = m6Vk
// module chunks = 0